import { ClassNameProps } from "../../models/Props"
import { classNames } from "../../style/common";

export type SquareEnixLogoProps = ClassNameProps;

export function SquareEnixLogo(props: SquareEnixLogoProps) {
    return (
        <svg version="1.1" className={classNames("fill-contrast-primary", props.className)} xmlns="http://www.w3.org/2000/svg" width="760px" height="95px" viewBox="-5.969 -13 760 95" enable-background="new -5.969 -13 760 95">
            <path d="M97,0c-6.648,0-12,5.352-12,12v45c0,6.648,5.352,12,12,12h16v9h15v-9h17c6.648,0,12-5.352,12-12V12
	c0-6.648-5.352-12-12-12H97z M100,12h41v44h-13v-7h-15v7h-13V12z"/>
            <path d="M14,0C7.352,0,2,5.352,2,12v16c0,6.648,5.352,12,12,12h44h2v16h-2H31H19h-2H0v1c0,6.648,5.352,12,12,12h5h2
	h42c6.648,0,12-5.352,12-12V39c0-6.648-5.352-12-12-12h-3H15V12h43v6h14v-6c0-6.648-5.352-12-12-12H14z"/>
            <path d="M169,0v12v45c0,6.648,5.352,12,12,12h8h9h1h8h17c6.648,0,12-5.352,12-12V12V0h-9h-5h-1v56h-14h-8h-1h-9h-5V0
	h-3H169z"/>
            <path d="M273.5,1L239,69h15l7.625-15h38.75L308,69h15L288.5,1L288,0h-14
	L273.5,1z M281,15.781L294.313,42h-26.625L281,15.781z"/>
            <path d="M330,0v12v19v38h15V43h9.5l25,26h20l-25-26h7.5c6.648,0,12-5.352,12-12V12c0-6.648-5.352-12-12-12h-37h-3H330
	z M345,12h30c2.216,0,4,1.784,4,4v11c0,2.216-1.784,4-4,4h-30V12z"/>
            <path d="M407,0v69h58V56h-43V12h43V0H407z" />
            <rect x="435" y="27" fill="#E20A16" width="25" height="13" />
            <path d="M497,0v69h58V56h-43V12h43V0H497z" />
            <rect x="525" y="27" fill="#E20A16" width="25" height="13" />
            <path d="M567,0v3.5V69h14V20.188l36,42.938l1,1.188L621.938,69H625h6h1V0h-1h-14v46.438L581,3.5L578.063,0H567z" />
            <rect x="644" width="16" height="69" />
            <path d="M667.938,0l30.031,33.344L667.75,69h18l21.5-25.344L730.063,69h18l-32.094-35.656L744.25,0h-18
	l-19.563,23.063L685.938,0H667.938z"/>
        </svg>
    )
}